export default __webpack_public_path__ + "static/media/sites.c7e21dda.svg";